export default {"src":"/_next/static/media/technext.deb3df06.svg","height":28,"width":132,"blurWidth":0,"blurHeight":0};